import he from "he";

const escapeHtmlCharsInCodeBlock = (value: string): string => {
  const regex = /<code[^>]*?>([\s\S]*?)<\/code>/gi;

  const resultValue = value.replace(regex, (match, content) => {
    const decodedContent = he.decode(content);
    const encodedContent = he.encode(decodedContent);
    return match.replace(content, encodedContent);
  });

  return resultValue;
};

const replaceNLSybmolWithBr = (value: string): string => {
  const replace = (text: string): string => {
    return text.replaceAll(/\n/g, "<br>");
  };

  const preRegex = /<pre>[\s\S]*?<\/pre>/gi;

  const parts = [];

  let lastIndex = 0;
  value.replace(preRegex, (match, index) => {
    const beforePre = value.slice(lastIndex, index);
    parts.push(replace(beforePre));
    parts.push(match);
    lastIndex = index + match.length;
    return "";
  });

  parts.push(replace(value.slice(lastIndex)));

  return parts.join("");
};

export { escapeHtmlCharsInCodeBlock, replaceNLSybmolWithBr };
